module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjY5NTEuODE0IDE3OS45NjggOS4yOTMgMTYuNTA5Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojOWY5ZjlmO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTAsOC4yMzYsOC4yMzYsMCw5LjI5MywxLjA1OCwyLjExNiw4LjIzNmw3LjE3OCw3LjIxNkw4LjIzNiwxNi41MDksMCw4LjI3M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY5NTEuODE0IDE3OS45NjgpIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail_left_arrow.svg
// module id = 214
// module chunks = 2